import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";

// Public Pages
import Home from "./pages/Home";
import Suppliers from "./pages/Suppliers";
import Buyers from "./pages/Buyers";
import About from "./pages/About";
import RequestAccess from "./pages/RequestAccess";
import TargetList from "./pages/TargetList";
import DistributorReps from "./pages/DistributorReps";
import BuildBrand from "./pages/BuildBrand";
import AIWorkforce from "./pages/AIWorkforce";
import AIBlueprint from "./pages/AIBlueprint";
import TradePay from "./pages/TradePay";
import BuyerMatch from "./pages/BuyerMatch";

// Checkout Pages
import Checkout from "./pages/Checkout";
import CheckoutSuccess from "./pages/CheckoutSuccess";
import CheckoutCancel from "./pages/CheckoutCancel";

// Auth Pages
import Login from "./pages/Login";
import Register from "./pages/Register";
import ForgotPassword from "./pages/ForgotPassword";

// Dashboard
import Dashboard from "./pages/dashboard/Dashboard";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            {/* Public Pages */}
            <Route path="/" element={<Home />} />
            <Route path="/suppliers" element={<Suppliers />} />
            <Route path="/buyers" element={<Buyers />} />
            <Route path="/about" element={<About />} />
            <Route path="/request-access" element={<RequestAccess />} />
            <Route path="/target-list" element={<TargetList />} />
            <Route path="/distributor-reps" element={<DistributorReps />} />
            <Route path="/build-brand" element={<BuildBrand />} />
            <Route path="/ai-workforce" element={<AIWorkforce />} />
            <Route path="/ai-blueprint" element={<AIBlueprint />} />
            <Route path="/trade-pay" element={<TradePay />} />
            <Route path="/buyer-match" element={<BuyerMatch />} />
            
            {/* Checkout Flow */}
            <Route path="/checkout" element={<Checkout />} />
            <Route path="/checkout/success" element={<CheckoutSuccess />} />
            <Route path="/checkout/cancel" element={<CheckoutCancel />} />
            
            {/* Auth Pages */}
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            
            {/* Dashboard (protected, role-based) */}
            <Route path="/dashboard" element={<Dashboard />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
